import { createBrowserHistory as createHistory, History } from 'history';
export const history: History = createHistory();
